import React, { useState } from "react";
import { WarmUpEmptyState } from "./WarmUpEmptyState";
import { GroupTypesEmptyState } from "./GroupTypesEmptyState";

// An empty class with warm_up_challenges on: the warm-up empty state, until
// "See all group types" swaps in the three-card view. The swap is local, so a
// new class (key) or a remount brings the warm-up view back.
export const WarmUpEmptyStates = ({
  onPickWarmUp,
  onSeeAllGroupTypes,
  style,
  focusTitle,
  onTitleFocused,
  ...groupTypes
}) => {
  const [showsAllGroupTypes, setShowsAllGroupTypes] = useState(false);

  if (showsAllGroupTypes) return <GroupTypesEmptyState style={style} {...groupTypes} />;

  return (
    <WarmUpEmptyState
      style={style}
      onPickWarmUp={onPickWarmUp}
      focusTitle={focusTitle}
      onTitleFocused={onTitleFocused}
      onSeeAllGroupTypes={() => {
        onSeeAllGroupTypes?.();
        setShowsAllGroupTypes(true);
      }}
    />
  );
};
